import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'template']

  add(event) {
    event.preventDefault()

    // Générer un timestamp unique comme faux ID
    const timestamp = new Date().getTime()

    // Récupérer le template et remplacer NEW_RECORD par le timestamp
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, timestamp)

    // Insérer le nouveau champ
    this.containerTarget.insertAdjacentHTML('beforeend', content)
  }

  remove(event) {
    event.preventDefault()

    const wrapper = event.target.closest('.nested-fields')

    // Si le champ a un input _destroy, le marquer pour destruction
    const destroyInput = wrapper.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = '1'
      wrapper.style.display = 'none'
    } else {
      // Sinon, simplement retirer du DOM
      wrapper.remove()
    }
  }
}
